import React, {useCallback} from 'react'
import Axios from '../../../axios-proas';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TD, YounovLink, Badge } from '../../../styles/Table.styled';
import { showColumn, getAlignPosition } from '../../../shared/utility';
import theme from '../../../styles/theme';
import { UserStatus } from '../../../containers/UsersManagement/UsersManagement.styled';
import EditIcon from '@mui/icons-material/Edit';
import { CTooltip } from '../../UI/CTooltip/CTooltip';

function TableBody(props) {
    const { clientsData,  columns, selectedRows, setSelectedRows} = props;
    const navigate = useNavigate();
    const {t} = useTranslation();
    const formatDate = useCallback((date) => {
        if (date !== null && date.valueOf() > 0){
            let newDate = new Date(date);
            let day = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()
            let month = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)
        return day + '/' + month + '/' + newDate.getFullYear()
        }else return null;    
    }, [])
  
    const getSelectedRowValue = (id) => {
        if (selectedRows) {
            return selectedRows[id] || false
        } else return false
    }
    const selectRowHandler = (e) => {
        let id = e.target.name;
        let val = e.target.checked;
        setSelectedRows(id, val)
    }
    function checkObjectMetaData(obj) {
        if (obj === null) {
            return false;
        } else {
            for (const key in obj ) {
                if (key != "hierarchieBailleur" && obj[key] !== null && obj[key] !== undefined && obj[key] !="")
                    return true
            }
            return false
        }
    }
    function checkObjectMetaDataHierarchieBailleur(obj) {
        if (obj === null) {
            return false;
        } else {
            for (const key in obj) {
                if (key == "hierarchieBailleur" && obj[key] !== null && obj[key] !== undefined && obj[key] != "") {
                    if (obj[key].children !== null && obj[key].children.length > 0) 
                        return true
                }
            }
            return false
        }
    }

    return (
        <>
            {
                clientsData ? clientsData.map(row => (
                    <tr key={row.id} className="clientTableBody__tr">
                        <TD>
                            <input type="checkbox" name={row.id} onChange={(e) => selectRowHandler(e)} checked={getSelectedRowValue(row.id)} className="form-check-input" id="exampleCheck1" />
                        </TD>
                        <TD style={{ display: !showColumn(columns, "raisonSociale") && 'none', textAlign: getAlignPosition(columns, "raisonSociale") }}>
                           
                                {row.raisonSociale}
                        
                        </TD>
                        <TD style={{ display: !showColumn(columns, "libelleCourt") && 'none', textAlign: getAlignPosition(columns, "libelleCourt") }}>{row.libelleCourt}</TD>

                        <TD style={{ display: !showColumn(columns, "adresseMail") && 'none', textAlign: getAlignPosition(columns, "codeGesCom") }}>{row.adresseMail}</TD>
                        
                      
                        <TD style={{ display: !showColumn(columns, "telephoneSupport") && 'none', textAlign: getAlignPosition(columns, "telephoneSupport") }}>{row.telephoneSupport}</TD>
                        <TD style={{ color: !checkObjectMetaDataHierarchieBailleur(row.metadata) && "red", display: !showColumn(columns, "hierarchieBailleur") && 'none', textAlign: getAlignPosition(columns, "hierarchieBailleur") }}>
                         
                            <UserStatus
                                style={{ background: checkObjectMetaDataHierarchieBailleur(row.metadata) ? theme.colors.success : theme.colors.danger }}
                                color={!row?.lockoutEnd ? "#fff" : "#fff"}
                            >
                                {checkObjectMetaDataHierarchieBailleur(row.metadata) ? "Oui" : "Non"}
                            </UserStatus>
                        </TD>
                        <TD style={{ color: !checkObjectMetaData(row.metadata) && "red", display: !showColumn(columns, "metadata") && 'none', textAlign: getAlignPosition(columns, "metadata") }}>
                           
                            <UserStatus
                                style={{ background: checkObjectMetaData(row.metadata) ? theme.colors.success : theme.colors.danger }}
                                color={!row?.lockoutEnd ? "#fff" : "#fff"}
                            >
                                {checkObjectMetaData(row.metadata) ? "Oui" : "Non"}
                            </UserStatus>
                        </TD>

                        <TD className="userManag_td">

                            <CTooltip title={"Consulter"} className="tableActions__icon">
                                <YounovLink
                                    style={{ marginLeft: "8px"} }
                                    color={"#1995ee"}
                                    to={`/entity/${row.id}`}
                                >
                                    <EditIcon className="editIcon" fontSize="small" style={{ color: "#2174B9", cursor: "pointer" }}  />
                                </YounovLink>

                               
                            </CTooltip>
                           
                        </TD>
                    </tr>
                )) : null
            }
        </>
    )
}

export default TableBody
